import { motion } from 'framer-motion';

import { DANGER_RED, EASE_IN_OUT, EASE_OUT, MUTED_GRAY } from '../constants';

interface ISPPipeProps {
  name: string;
  latency: string;
  status: string;
  color: string;
  failed?: boolean;
  delay?: number;
}

export function ISPPipe({ name, latency, status, color, failed = false, delay = 0 }: ISPPipeProps) {
  const pipeColor = failed ? DANGER_RED : color;

  return (
    <motion.div className='flex items-center gap-3 py-2' initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ delay, duration: 0.4, ease: EASE_OUT }} viewport={{ once: true }}>
      <motion.div className='size-2.5 shrink-0 rounded-full' style={{ backgroundColor: pipeColor, boxShadow: `0 0 8px ${pipeColor}60` }} animate={failed ? { opacity: [1, 0.3, 1] } : { opacity: 1 }} transition={failed ? { duration: 0.6, repeat: Infinity } : {}} />

      <div className='relative h-1 flex-1 overflow-hidden rounded-full' style={{ backgroundColor: `${pipeColor}20` }}>
        <motion.div className='absolute inset-y-0 start-0 rounded-full' style={{ backgroundColor: pipeColor }} animate={failed ? { width: ['100%', '30%', '0%'] } : { width: ['0%', '100%'] }} transition={failed ? { duration: 1.5, ease: EASE_IN_OUT } : { duration: 1.5, delay: delay + 0.3, ease: EASE_OUT, repeat: Infinity, repeatType: 'loop' as const }} />
      </div>

      <div className='flex min-w-[180px] items-center gap-3'>
        <span className='text-xs font-medium' style={{ color: pipeColor, fontFamily: 'var(--font-outfit)' }}>
          {name}
        </span>
        <span className='font-mono text-xs tabular-nums' style={{ color: failed ? DANGER_RED : MUTED_GRAY }}>
          {failed ? 'FAIL' : latency}
        </span>
        <span className='rounded-full px-1.5 py-0.5 text-[10px] uppercase tracking-wider' style={{ backgroundColor: failed ? `${DANGER_RED}20` : `${pipeColor}15`, color: failed ? DANGER_RED : pipeColor }}>
          {failed ? 'Down' : status}
        </span>
      </div>
    </motion.div>
  );
}
